import { di } from 'react-magnetic-di';

type Props = {
	url: string;
};

const FullPageRedirect = ({ url }: Props) => {
	di(window);
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window.location.assign(url);
	return null;
};

export default FullPageRedirect;
